import { ID } from '@phi/newtype';
import { ThumbnailSize } from '@phi/onshape';
import { PropType, defineComponent, h } from 'vue';
import { onshapeThumbnail } from '@phi/frontend/api/calls';
import { Option } from '@vaaas/fpts/option';
import { OnshapeLogo } from '@components/icons';
import { utility } from '@phi/components';

export default defineComponent({
    props: {
        document: {
            required: true,
            type: String as any as PropType<ID<'document'>>,
        },

        workspace: {
            required: true,
            type: String as any as PropType<ID<'workspace'>>,
        },

        size: {
            required: false,
            type: String as any as PropType<ThumbnailSize>,
            default: '70x40',
        },

        fetch: {
            required: false,
            type: Function as PropType<typeof onshapeThumbnail>,
            default: onshapeThumbnail,
        },
    },

    data() {
        return {
            data_uri: undefined as Option<string>,
        };
    },

    mounted() {
        this.fetch(this.document, this.workspace, this.size)
            .then(x => {
                if (x instanceof Error)
                    return;
                else
                    this.data_uri = x;
            });
    },

    render() {
        return this.data_uri
            ? h('img', { class: ['thumbnail', utility.no_interact], src: this.data_uri })
            : h('span', { class: ['thumbnail', utility.no_interact] }, OnshapeLogo(false));
    },
});
